import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            border: "2px solid #0A0A0A",
            boxShadow: "4px 4px 0 0 #0A0A0A",
            background: "#FFFDF9",
            color: "#0A0A0A",
            fontFamily: "Figtree, sans-serif",
            fontWeight: 600,
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
}

export default App;
